export default "__VITE_ASSET__$_D7MdFI__"